var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { live } from 'lit/directives/live.js';
import { BwElement } from './base/bw-element.js';
let BwCheckbox = class BwCheckbox extends BwElement {
    constructor() {
        super(...arguments);
        this.checked = false;
        // Tri-state for "All tracks" headers (export window, 2026-10-07): some of the
        // children are on, some off. Drawn as a dash; the native input carries it to
        // assistive tech as "mixed". A user toggle always resolves it — see _onChange.
        // Keep `checked=false` while indeterminate, so a click reports `{checked:true}`
        // ("select all") rather than flipping an already-checked box to false.
        // A consumer that owns the state may re-assert it from the change handler; the
        // template binds both flags through live() so that write reaches the native
        // input even though the browser has already cleared it behind Lit's back.
        this.indeterminate = false;
        this.disabled = false;
        this.label = '';
        this.name = '';
        this.value = '';
        // Accessible name for label-less checkboxes (no `label` prop, no slotted
        // text). Callers set `aria-label` on the HOST, but the actual interactive
        // element is `.bw-checkbox-native` — an inner <input> wrapped by a <label>
        // that has no accessible name of its own, so AT never heard the host's
        // aria-label. Redeclaring `ariaLabel` as a Lit property (normally inherited
        // from ARIAMixin on HTMLElement) lets us observe the attribute and forward
        // it to the native input. `reflect: true` keeps it on the host attribute
        // too, so existing `[aria-label]` queries on the host still work.
        this.ariaLabel = null;
    }
    _onChange(e) {
        this.checked = e.target.checked;
        // The browser has already cleared the native flag on click; mirror that on
        // the property so the host attribute and the next render agree with it.
        this.indeterminate = false;
        this.dispatchEvent(new CustomEvent('bw-checkbox-change', {
            detail: { checked: this.checked }, bubbles: true, composed: true,
        }));
    }
    render() {
        return html `
      <label class="bw-checkbox-row">
        <input class="bw-checkbox-native" type="checkbox"
          .checked=${live(this.checked)} .indeterminate=${live(this.indeterminate)}
          ?disabled=${this.disabled}
          name=${this.name || nothing} value=${this.value || nothing}
          aria-label=${this.ariaLabel ?? nothing}
          @change=${this._onChange}>
        <span class="bw-checkbox-box" aria-hidden="true"></span>
        ${this.label ? html `<span class="bw-checkbox-label">${this.label}</span>` : html `<slot></slot>`}
      </label>
    `;
    }
    firstUpdated() { this.projectSlots(); }
};
__decorate([
    property({ type: Boolean, reflect: true })
], BwCheckbox.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwCheckbox.prototype, "indeterminate", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwCheckbox.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], BwCheckbox.prototype, "label", void 0);
__decorate([
    property({ type: String })
], BwCheckbox.prototype, "name", void 0);
__decorate([
    property({ type: String })
], BwCheckbox.prototype, "value", void 0);
__decorate([
    property({ type: String, attribute: 'aria-label', reflect: true })
], BwCheckbox.prototype, "ariaLabel", void 0);
BwCheckbox = __decorate([
    customElement('bw-checkbox')
], BwCheckbox);
export { BwCheckbox };
//# sourceMappingURL=bw-checkbox.js.map